module.exports = __webpack_public_path__ + "img/lxwm.94872637.png";